import { Link, useLocation } from "react-router-dom";
import {
  getBrandCode,
  getAmazonBrandCode,
  getPortcoDisplayName,
} from "../utils/brandMapping";

interface PortcoSubNavProps {
  portcoId: string;
}

function baseTabs(portcoId: string) {
  return [
    { label: "Overview", path: `/portco/${portcoId}` },
    { label: "Pacing", path: `/portco/${portcoId}/pacing` },
    { label: "Inventory", path: `/portco/${portcoId}/inventory` },
    { label: "Sales by Item", path: `/portco/${portcoId}/sales-by-item` },
  ];
}

function dtcTab(portcoId: string) {
  const brandCode = getBrandCode(portcoId);
  if (brandCode) {
    return { label: "Shopify / DTC", path: `/portco/dtc/${brandCode}` };
  }
  const name = getPortcoDisplayName(portcoId);
  return {
    label: "Shopify / DTC",
    path: `/portco/dtc/coming-soon?from=${portcoId}&name=${encodeURIComponent(name)}`,
  };
}

function amazonTab(portcoId: string) {
  const brandCode = getAmazonBrandCode(portcoId);
  if (brandCode) {
    return { label: "Amazon", path: `/portco/amazon/${brandCode}` };
  }
  const name = getPortcoDisplayName(portcoId);
  return {
    label: "Amazon",
    path: `/portco/amazon/coming-soon?from=${portcoId}&name=${encodeURIComponent(name)}`,
  };
}

export function PortcoSubNav({ portcoId }: PortcoSubNavProps) {
  const { pathname } = useLocation();
  const tabs = [...baseTabs(portcoId), dtcTab(portcoId), amazonTab(portcoId)];

  return (
    <div className="flex gap-1 overflow-x-auto">
      {tabs.map((tab) => {
        const isActive =
          pathname === tab.path || pathname.startsWith(tab.path.split("?")[0]);
        return (
          <Link
            key={tab.label}
            to={tab.path}
            className={`px-3 py-1.5 text-sm font-medium rounded-md no-underline transition-colors whitespace-nowrap flex-shrink-0 ${
              isActive
                ? "bg-wmp-500 text-white shadow-sm"
                : "text-gray-500 hover:text-gray-900 hover:bg-gray-100"
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
